<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header :title="title" searchable="true"></list-nav-header>

            <filter-bar :hide-all="approving" :filters="filters" class="hidden-mobile"></filter-bar>

            <div v-if="show_payment_dates" class="secondary-filter-bar hidden-mobile">
                <h3>Planned Payment Dates</h3>
                <a href="#" :class="{active: payment_date == null}" @click.prevent="payment_date = null">Any</a>
                <a href="#" :class="{active: payment_date == date}" v-for="(amounts,date) in payment_dates"
                   @click.prevent="payment_date = date">{{ date }} <span>{{ amounts.qty }} @ £{{ amounts.value }}</span></a>
            </div>

            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items">
                        <div class="icon">
                            <i class="fa fa-square red" aria-hidden="true" v-if="item.voided" title="Voided"></i>
                            <span v-else>
                                <i class="fa fa-square green" aria-hidden="true" v-if="item.approved_at"
                                   title="Approved"></i>
                            </span>
                        </div>
                        <a :href="item._links.frontend.view" class="info">
                            <span>{{ item.supplier }}</span>
                            <span>{{ item.raised }}</span>
                            <span>{{ item.supplier_reference }}</span>
                            <span>£{{ item.costs.due }}</span>
                        </a>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Orders
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col" v-if="view_all">#</th>
                        <th scope="col">Supplier Reference</th>
                        <th scope="col" v-if="view_all">Supplier</th>
                        <th scope="col">Package</th>
                        <th scope="col" v-if="view_all">Invoice Date</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col" v-if="view_all">Approval</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference" v-if="view_all"><a :href="item._links.frontend.view">{{ item.reference
                            }}</a></td>
                        <td data-label="Supplier Reference"><a :href="item._links.frontend.view">{{ item.supplier_reference }}</a></td>
                        <td data-label="Supplier" v-if="view_all">{{ item.supplier }}</td>
                        <td data-label="Package" v-if="item.package"><a :href="item.package.data._links.frontend.view"><strong>{{
                            item.package.data.project }}:</strong> {{
                            item.package.data.name }}</a></td>
                        <td data-label="Package" v-else>No Package</td>
                        <td data-label="Invoice Date" v-if="view_all">{{ item.raised }}</td>
                        <td data-label="Due Date">{{ item.delivery_date }}</td>
                        <td data-label="Amount">&pound;{{ item.costs.due }}</td>
                        <td data-label="Status">{{ item.status }}</td>

                        <template v-if="view_all">
                            <td v-if="item.approved_at" data-label="Approval">{{ item.approved_by.name }} on {{ item.approved_at
                                }}
                            </td>
                            <td v-else data-label="Approval">
                                To be approved by {{ item.contact }}
                            </td>
                        </template>

                    </tr>
                    <tr>
                        <td colspan="6">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Invoices
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props: ['compact', 'supplierId', 'supplierType', 'packageId', 'onlyMine','approving','justYours'],
        data() {
            return {
                name: 'pis',
                items: [],
                statuses: [],
                payment_dates: {},
                payment_date: null,
                filtered: false,
                nextPaginationUrl: '',
                search_query: null
            }
        },
        filters: {

        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            },
            supplierId: function () {
                this.getItems();
            },
            supplierType: function () {
                this.getItems();
            },
            filtered: function () {
                this.getItems();
            },
            payment_date: function (newVal,oldVal) {
                if(newVal != oldVal)
                {
                    this.getItems();
                }
            }
        },
        computed: {
            title() {
                if (this.onlyMine) {
                    return 'Purchase Invoices You\'re Responsible For';
                }

                return 'Purchase Invoices';
            },
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            view_all() {
                if (this.compact === true || this.compact == 'true') {
                    return false;
                }

                return true;
            },
            is_filtered() {
                if (this.filtered === false) {
                    return false;
                }

                return true;
            },
            filters: function () {
                var filters = {};
                if(this.approving)
                {
                    if(!this.justYours)
                    {
                        filters['Awaiting Approval'] = 'Awaiting Approval By Anyone';
                    }
                    filters['my_approval'] = 'Awaiting Approval By Me';
                    filters['previously_approved_by_me'] = 'Previously Approved By Me';
                }else{
                    _.forEach(this.statuses, function (status) {
                        filters[status] = status.charAt(0).toUpperCase() + status.slice(1);
                    });
                    filters['my_approval'] = 'Awaiting Approval By Me';
                }
                return filters;
            },
            show_payment_dates: function () {
                return !_.isEmpty(this.payment_dates);
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.pis.index;
                var params = {};
                this.items = [];

                if (this.has_query) {
                    params.query = this.search_query;
                }

                if (this.onlyMine) {
                    params.mine = true;
                }

                if (this.supplierId) {
                    params.supplier_id = this.supplierId;
                    params.supplier_type = this.supplierType;
                }

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                if(this.approving && !this.is_filtered)
                {
                    window.eventBus.$emit('filter-bar-changed', 'my_approval',this.filters['my_approval']);
                    this.filtered = 'my_approval';
                }else{
                    var hasGetVariable = location.search.indexOf('filter=') >= 0;
                    if (hasGetVariable && !this.is_filtered) {
                        window.eventBus.$emit('filter-bar-changed', getParameterByName('filter'),this.filters[getParameterByName('filter')]);
                        this.filtered = getParameterByName('filter');
                    }
                }

                if (this.is_filtered) {
                    params.filter = this.filtered;
                }

                if (this.payment_date) {
                    params.payment_date = this.payment_date;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.statuses = response.data.meta.statuses;
                        that.payment_dates = response.data.meta.planned_payment_dates;
                        if (_.isEmpty(that.payment_dates)) {
                            that.payment_date = null;
                        }
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('filter-bar-changed', function (value) {
                that.filtered = value;
            });

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    .secondary-filter-bar {
        text-align: right;
        padding: 1em 0;
        border-top: 1px solid #f0f1f2;
        h3 {
            font-size: 16px;
            opacity: 0.8;
        }
        a {
            background-color: #f0f1f2;
            color: #889196;
            display: inline-block;
            font-size: 12px;
            padding: 0.3em 1em;
            text-decoration: none;
            font-weight: 500;
            border-radius: $standardBorderRadius;
            margin-left: 5px;
            transition: none;
            margin-bottom: 5px;
            span{
                font-weight:300;
                display:inline-block;
                margin-left:5px;
            }
            &:first-of-type {
                margin-left: 0;
            }
            &:hover, &.active {
                background-color: $brand;
                color: #fff;
            }
        }
    }
</style>
